import { getLogo, getTextLogo, getTitle } from "../../js/constants/global-variables.js";
import TranslationService, { _t } from "../../services/TranslationService.js";

let Bottombar = {
    render: async () => {
        const currentLang = localStorage.getItem('lang');
        let view =  /*html*/`
        <section class="footer">
            <div class="footerWrapper">
                <div class="hpf-BackToTop_Button"><div class="hpf-BackToTop_Button_Text">${_t('Kthehu ne fillim')}</div></div>
                <div class="footer-logo">
                ${
                    getTextLogo() ? `<span>${getTextLogo()}</span>` : `<img src="${getLogo() ?? ''}" alt="${getTitle() ?? ''}" style="max-width: 150px" />` 
                }
                </div>
                <select id="login_language_switch_footer" class="hpf-select" style="width: 80%; max-width: 260px; margin: 0 auto 24px; border-radius: 5px; padding: 5px;">
                ${
                    TranslationService.languages.map(lang => {
                        return `<option value="${lang.key}" ${lang.key === currentLang ? 'selected' : ''}>${lang.name}</option>`;
                    }).concat('')
                }
                </select>
                <div class="hpf-FooterModule_Links"><div class="hpf-HelpItem">${_t('Rregullore')}</div><div class="hpf-HelpItem">${_t('Responsible Gambling')}</div><div class="hpf-HelpItem">${_t('Privacy Policy')}</div></div>
                <p>${_t('Kjo faqe përdor cookiet e saj si dhe cookie të palëve të treta për të përmirësuar shërbimet, për të analizuar dhe personalizuar preferencat tuaja. Në qoftë se ju vazhdoni të lundroni, ne konsiderojmë që ju i pranoni cookiet. Ju mund të ndryshoni konfigurimet dhe të merrni më tepër informacion te Cookie Policy. Aksesi te lojrat e fatit online në disa shtete është i ndaluar me ligj. Është në përgjegjësinë e lojtarit për të siguruar që po vepron sipas ligjit kur akseson ketë faqe.')}</p>
                <p>${_t('Lojrat e fatit sjellin pasoja ekonomike dhe varësi ndaj tyre. Luaj në mënyrë të përgjegjshme.')}</p>
                <p>© 2016-${new Date().getFullYear()}</p>
            </div>
        </section>
        `
        return view
    },
    after_render: async () => {
        $('#login_language_switch_footer').on('change', (event) => {
            TranslationService.setLanguage(event.target.value);
        });

        $('body .hpf-BackToTop_Button_Text').on('click', (event) => {
            event.preventDefault();
            let body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, 500, 'swing');
        })



        if (window.location.host === 'ultrabet.uno') {
        $('#login_language_switch_login option').not('[value="it"]').remove();
        $('#login_language_switch_footer option').not('[value="it"]').remove();
        setTimeout(() => {
            $('#login_language_switch_login option').not('[value="it"]').remove();
            $('#login_language_switch_footer option').not('[value="it"]').remove();
        }, 2000);
        }
    }

}

export default Bottombar;
